import axios from "axios";
import { Message } from "@/message";
import { UserInfoInputModel } from "@/model/user-info/user-info-input.model";
import { UserInfoChecker } from "@/model/user-info/functions/user-info-input-checker";

export class AddressUtils {

    /**
     * 住所情報エンドポイントをコールします。
     * @param postalCode 郵便番号
     * @param callback 情報取得後に実行するコールバック関数（HTTPステータスコード、住所情報）
     */
    private static getAddressByPostalCode(postalCode: string, callback: (status: number, address: any) => void) {
        axios.get(`/address?postalCode=${postalCode}`)
            .then(cb => {
                callback(cb.status, cb.data)
            })
            .catch(error => {
                // エラーとなっても処理は継続させる
                const status = error.response ? error.response.status : 500;
                callback(status, null)
            });
    }

    /**
     * 郵便番号から住所情報を検索します。
     * @param model 会員情報
     * @param message 会員情報エラーメッセージ
     * @param vue vueオブジェクト
     */
    public static searchAddress(model: UserInfoInputModel, vue: any): Promise<void> {
        return new Promise<void>(resolve => {
            AddressUtils.getAddressByPostalCode(model.postalCode, (status, response) => {
                if ((status === 200) && response.prefecture && response.city) {
                    model.prefecture = response.prefecture;
                    model.city = response.city;
                    vue.$mount();
                } else {
                    // 見つからない場合は都道府県、市区町村をクリアして、エラーメッセージを表示
                    model.errorMessages.postalCodeErrorMsg = Message.NOT_FOUND_ADDRESS;
                    model.prefecture = "";
                    model.city = "";
                }
                resolve();
            });
        });
    }
}